/**
 * @module store/getters
 */

/** User */
export const User = state => state.user;
/** ProdVarIngr */
export const ProdVarIngr = state => state.prodVarIngr.filter(pvi => pvi.active);
/** Tag */
export const Tag = state => state.tags.filter(tag => tag.active);
/** Tavolo */
export const Tavolo = state => state.tavoli;
/** Menu */
export const Menu = state => state.menu;
/** Listino */
export const Listino = state => state.listini;
/** Allergeni */
export const Allergeni = state => state.allergeni;

/** toolbarActions */
export const toolbarActions = state => state.toolbarActions;
/** toolbarTitle */
export const toolbarTitle = state => state.toolbarTitle;

/** loading */
export const loading = state => state.loading_queue.length > 0;
/** load_state */
export const load_state = state => state.load_state;

/** currentListino */
export const currentListino = state => state.currentListino || (state.listini.length > 0 && state.listini.find(listino => listino.main)._id);

/** lingue */
export const lingue = state => state.lingue;

/** lastError */
export const lastError = state => state.lastError;
/** lastMessage */
export const lastMessage = state => state.lastMessage;
/** lock state */
export const lock = state => state.lock;
/** changed state */
export const changed = state => state.changed;
/** lib current tab */
export const libSelectedTab = state => state.libSelectedTab;
/** lib current group filter */
export const libCurrentFilter = state => state.libCurrentFilter;
/** lib group filters */

export const libGroupFilters = state => target => state.filters[target];
/** stampanti */
export const stampanti = state => state.user.stampanti;
/** reparti */
export const reparti = state => state.user.reparti;
/** filtered pvi */
export const filteredPvi = state => {
    return (filterText, target) => {
        let find = (obj, things) => {
            function checkType() {
                switch (state.libSelectedTab) {
                    case 'prod':
                        return utils.isProdotto(obj);
                    case 'var':
                        return utils.isVariante(obj);
                    case 'ingr':
                        return utils.isIngrediente(obj);
                    case 'group':
                        return true;
                }
            }

            const prepOne = things ? _.find(obj.tags, tag => tag == things) !== undefined : true;
            const prepTwo = checkType();
            const prepThree =
                utils
                    .getMainDesc(obj)
                    .toLowerCase()
                    .indexOf(filterText.toLowerCase()) != -1;

            return prepOne && prepTwo && prepThree;
        };

        if (state.libSelectedTab == 'group') {
            let filteredData = _.filter(Tag(state), element => find(element));

            filteredData = _.chain(filteredData)
                .sortBy(item => utils.getMainDesc(item).toLowerCase())
                .sortBy(item => item.livello)
                .value();

            if (filteredData.length === Tag(state).length) {
                let treeList = [];
                let childsMap = [];

                //makes the filtered list into a tree with the first child being an array with all the fathers
                filteredData.forEach(tag => {
                    let idPadre = typeof tag.padre === 'undefined' || tag.padre == null ? 0 : tag.padre;

                    if (!childsMap.hasOwnProperty(idPadre)) {
                        childsMap[idPadre] = [];
                    }

                    childsMap[idPadre].push(tag);
                });

                // puts the level description in all tags
                function explodeTree(childList, levelDescription = 'BASE') {
                    childList.forEach(child => {
                        child.levelDescription = levelDescription;

                        treeList.push(child);

                        if (childsMap.hasOwnProperty(child._id)) {
                            explodeTree(childsMap[child._id], levelDescription + ' - ' + utils.getMainDesc(child));
                        }
                    });

                    return treeList;
                }

                return explodeTree(childsMap[0]);
            } else if (filteredData.length) {
                return filteredData;
            } else {
                return [];
            }
        } else {
            let res = [];
            if (state.filters[target].specific != null) {
                res = _.filter(ProdVarIngr(state), o => {
                    return find(o, state.filters[target].specific._id);
                });
            } else if (state.filters[target].selected != null) {
                res = _.filter(ProdVarIngr(state), o => {
                    return find(o, state.filters[target].selected._id);
                });
            } else {
                res = _.filter(ProdVarIngr(state), o => {
                    return find(o);
                });
            }

            res.forEach(pvi => {
                pvi.levelDescription = pvi.tags.reduce((curr, next) => {
                    return `${curr} - ${utils.getMainDesc(Tag(state).find(tag => tag._id == next))}`;
                }, 'BASE');
            });

            return _.sortBy(res, item => utils.getMainDesc(item).toLowerCase());
        }
    };
};

export const filteredTags = state => {
    return target => {
        let res = [];
        if (state.filters[target].selected) {
            res = _.filter(Tag(state), {padre: state.filters[target].selected._id});
            return _.sortBy(res, item => utils.getMainDesc(item)).concat({tipo: 'GOBACK', _id: 'GOBACK'});
        } else {
            res = _.filter(Tag(state), {padre: null});
            return _.sortBy(res, item => utils.getMainDesc(item));
        }
    };
};

/** Terminals */
export const Terminals = state => {
    return state.terminals;
};

/** Operators */
export const Operators = state => state.operators;

/** Operators Rights */
export const OperatorsRights = state => state.userRightsTemplate;

/** Payment Types */
export const PaymentTypes = state => state.paymentTypes;

/** Discount Types */
export const DiscountTypes = state => state.discountTypes;

/** Italian Cities */
export const ItalianCities = state => state.italianCities;



// WEBPACK FOOTER //
// ./src/store/getters.js